/**
 * Extracts and returns the initials from the given name.
 *
 * This function takes a full name as input, splits it into its individual words,
 * and retrieves the first character of each word. The resulting initials are then
 * concatenated, converted to uppercase, and trimmed to the first two characters.
 *
 * @param {string} name - The full name from which to extract initials.
 * @returns {string} A string containing the uppercase initials of the name, limited to two characters.
 */
export const getInitials = (name) => {
    return name
        .split(" ")
        .map((item) => item.at(0))
        .join("")
        .slice(0, 2)
        .toUpperCase();
};
